export function debounce<TArgs extends unknown[]>(
  func: (this: unknown, ...args: TArgs) => void,
  wait: number,
  immediate?: boolean,
): (this: unknown, ...args: TArgs) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return function (this: unknown, ...args: TArgs) {
    const later = () => {
      timeout = null;
      if (!immediate) {
        func.apply(this, args);
      }
    };

    const callNow = immediate && !timeout;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(this, args);
    }
  };
}
